<template>
  <div>
    <vehicle-form
      :vehicle="vehicle"
      :submit="submit"
      :buttonText="t('create')"
      :onInput="() => {}"
      :loading="loading"
    />
  </div>
</template>

<script setup lang="ts">
import VehicleForm from './Form.vue'
import Say from '@/utils/Say'
import { defineComponent, computed, ref, onBeforeMount } from 'vue';
import store from '@/store';
import { vehicleStore } from '@/store/vehicles'
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import sayErrorResponse from '@/mixins/sayErrorResponse'

defineComponent({
  VehicleForm
})

const loading = ref(false)
const router = useRouter()
const { t } = useI18n()

const vehicle = computed(() => {
  return vehicleStore.getters.vehicle
})

onBeforeMount(() => {
  vehicleStore.commit('clearVehicle')

  store.commit('app.setPageTitle', t('vehicleCreate'))
  store.commit('app.setBreadcrumbs', [
    { text: t('vehicle', 2), routeName: 'VehiclesList' },
    { text: t('vehicleCreate') }
  ])
})

const submit = () => {
  loading.value = true
  vehicleStore.dispatch('createVehicle', vehicle.value).then(() => {
    loading.value = false
    Say('success', t('vehicleCreateSuccess'))
    router.push({ name: 'VehiclesList' })
  }).catch((err) => {
    loading.value = false
    sayErrorResponse(err)
  })
}
</script>
